import React from "react";

import "./PaymentSummary.scss";
import { fromCentsToPounds } from "../../../helpers/money";
import Icon from "../../components/Icon/Icon";
import { getUserDisplayName } from "../../../helpers/userDisplayName";


const PAYMENT_TYPES = {
    purchase_physical: { icon: "physical_sales_tab" },
    purchase_digital: { icon: "digital_sales_tab" },
    contribution: { icon: "one_month_contribution_tab" },
    monthly_contribution: { icon: "month_contribution_tab" },
}

/**
 * @param {'paymentHistory' | 'earnings'} variant
 *   paymentHistory — outgoing payments: show recipient (beneficiary / seller).
 *   earnings — incoming payments: show payer (grantor / buyer).
 */
function PaymentSummary({ payment, variant = "earnings" }) {
    const counterparty =
        variant === "paymentHistory" ? payment?.beneficiary : payment?.grantor;

    const date = new Date(payment?.created_at); // Multiply by 1000 for milliseconds

    // Format the date
    const formattedDate = date.toLocaleDateString("en-GB", {
        year: "numeric", // Full numeric year (e.g., 2023)
        month: "short", // Short month name (e.g., Mar)
        day: "2-digit", // Two-digit day (e.g., 23)
    });

    const displayName = getUserDisplayName(counterparty) || payment?.guest_username || payment?.guest_name || "Guest";

    return (
        <div className="payment-summary py-16">
            <div className="d-flex aic gap-12">
                <div>
                    <Icon
                        className="p-4"
                        alias={PAYMENT_TYPES[payment?.type]?.icon || "box"}
                        height={40}
                        width={40}
                        color="#ff0000"
                    />
                </div>
                <div className="flex-1">
                    {payment?.order?.order_status === 'pending' && <div className="pending-status">Pending</div>}
                    <div className="d-flex jcsb aic pb-4">
                        <div className="beneficiary-name">
                            {displayName}
                        </div>
                        <div className="pricepayment">
                            {fromCentsToPounds(payment?.amount || 0)}
                        </div>
                    </div>
                    <div className="creation-name">
                        {payment?.creation?.title
                            ? `${payment.creation.title} • ${formattedDate}`
                            : formattedDate}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentSummary;
